module.exports = __webpack_public_path__ + "img/main-img.ef888721.png";